module.exports = __webpack_public_path__ + "img/Mask Group 2923@2x.be878733.png";